export default __webpack_public_path__ + "static/media/illustration-recruit-1-w@2x.4c5ea1d0.webp";